<template>
  <div class="cancelFee">
    <!-- <Nav :title="title" :back="1"></Nav> -->
    <div class="content" :class="{ isIosx: isiOSX }">
      <div class="tipphoto">
        <img src="./../../assets/takingCar/illu@2x.png" alt="" />
      </div>
      <div class="tip">
        <h2>司机正在赶来您的路上，建议您再等等～</h2>
        <p v-if="short_name == 'YangGuang'">
          根据阳光出行规则，您现在取消订单，可能需要支付给司机<span>
            3-5元 </span
          >的补偿费。
        </p>
      </div>
    </div>
    <div class="footbtn">
      <div class="btn">
        <div @click="escBtn" class="escbtn">我再想想</div>
        <div @click="confirmBtn" class="confirmbtn">确认取消订单</div>
      </div>
      <p @click="goCancelFee" v-if="short_name == 'YangGuang'">
        阳光出行实时单取消规则
        <img src="./../../assets/takingCar/moreright.png" alt="" />
      </p>
    </div>
  </div>
</template>

<script>
import Nav from "./nav";
export default {
  data() {
    return {
      isiOSX: false,
      token: "",
      taxis_order_sn: "",
      is_need_cancel_fee: "-1",
      short_name: "CaoCao",
    };
  },
  components: { Nav },
  created() {
    this.token = this.$route.query.token;
    this.isiOSX = this.isIphoneX();
    if (this.$route.query.taxis_order_sn) {
      this.taxis_order_sn = this.$route.query.taxis_order_sn;
    }
    if (this.$route.query.short_name) {
      this.short_name = this.$route.query.short_name;
    }
    // if (this.$route.query.is_need_cancel_fee) {
    //   this.is_need_cancel_fee = this.$route.query.is_need_cancel_fee;
    // }
    // console.log(this.taxis_order_sn);
  },
  methods: {
    escBtn() {
      this.params("", "", "goBack");
    },
    confirmBtn() {
      this.$router.push({
        path: "/takingCar/cancelReason",
        query: {
          token: this.token,
          taxis_order_sn: this.taxis_order_sn,
          is_need_cancel_fee: this.is_need_cancel_fee,
        },
      });
    },
    goCancelFee() {
      this.$router.push({
        path: "/takingCar/cancelRules",
      });
    },
  },
  mounted() {},
};
</script>

<style lang="less">
.cancelFee {
  background: #ffffff;
  min-height: 100%;
  .content {
    padding-top: 70px;
    margin: 0px 15px 0px;
    padding-bottom: 110px;
    .tipphoto {
      width: 265px;
      margin: 0 auto;
      img {
        width: 100%;
      }
    }
    .tip {
      margin: 22px 31px 10px;
      h2 {
        color: #333333;
        font-size: 20px;
        line-height: 28px;
      }
      p {
        color: #999999;
        font-size: 15px;
        line-height: 21px;
        span {
          color: #eaa700;
        }
      }
    }
  }
  .footbtn {
    width: 100%;
    position: fixed;
    bottom: 30px;
    left: 0;
    .btn {
      width: 90%;
      margin: 0 auto;
      div {
        line-height: 50px;
        margin-bottom: 16px;
        border: 1px solid #181818;
        border-radius: 5px;
        text-align: center;
      }
      .escbtn {
        background-color: #ffffff;
      }
      .confirmbtn {
        margin-top: 16px;
        background-color: #181818;
        color: #ffffff;
      }
    }
    p {
      text-align: center;
      color: #999999;
      font-size: 15px;
      line-height: 20px;
      img {
        width: 9px;
      }
    }
  }

  @media screen and (max-width: 350px) {
    .content {
      .tipphoto {
        width: 170px;
        margin: 0 auto;
        img {
          width: 100%;
        }
      }
      .tip {
        margin: 18px 31px 6px;
        h2 {
          color: #333333;
          font-size: 16px;
          line-height: 28px;
        }
        p {
          color: #999999;
          font-size: 12px;
          line-height: 21px;
          span {
            color: #eaa700;
          }
        }
      }
    }
    .footbtn {
      width: 100%;
      position: fixed;
      bottom: 30px;
      left: 0;
      .btn {
        width: 90%;
        margin: 0 auto;
        display: flex;
        justify-content: space-between;
        // border: 1px solid red;
        div {
          width: 47%;
          line-height: 35px;
          // margin-bottom: 16px;
          border: 1px solid #181818;
          border-radius: 5px;
          text-align: center;
        }
        .escbtn {
          background-color: #ffffff;
        }
        .confirmbtn {
          margin-top: 0px;
          background-color: #181818;
          color: #ffffff;
        }
      }
      p {
        text-align: center;
        color: #999999;
        font-size: 15px;
        line-height: 20px;
        img {
          width: 9px;
        }
      }
    }
  }

  .isIosx {
    padding-top: 90px;
  }
}
</style>
